import React from "react";
import { Radio, Layers } from "lucide-react";
import { developCards, receiveItems } from "../mock";

export default function Develop() {
  return (
    <section className="relative py-20 md:py-28">
      <div className="orb" style={{ width: 360, height: 360, background: "#0a4d68", left: "50%", top: 40, opacity: 0.25 }} />
      <div className="relative mx-auto max-w-7xl px-5">
        <div className="text-center reveal max-w-3xl mx-auto">
          <span className="kicker">Ce que tu développes</span>
          <h2 className="font-display text-3xl md:text-5xl font-semibold text-white mt-3">
            Quatre axes de{" "}
            <span className="gold-gradient-text">transformation</span>
          </h2>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 gap-6">
          {developCards.map((c) => (
            <div key={c.n} className="reveal glass card-hover rounded-3xl p-8 relative overflow-hidden">
              <span className="absolute -top-4 right-4 font-display text-7xl text-white/5 select-none">
                {c.n}
              </span>
              <h3 className="font-display text-xl md:text-2xl text-white pr-16">{c.title}</h3>
              <ul className="mt-5 space-y-2.5">
                {c.points.map((p) => (
                  <li key={p} className="text-white/65 text-[15px] pl-4 border-l border-[#e8c874]/25">{p}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* What you receive - premium */}
        <div className="mt-24 reveal">
          <div className="glass-strong rounded-[2rem] p-8 md:p-12">
            <div className="text-center max-w-2xl mx-auto">
              <span className="kicker">Ce que tu reçois</span>
              <h2 className="font-display text-3xl md:text-4xl font-semibold text-white mt-3">
                Et pourquoi c'est premium
              </h2>
            </div>
            <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-4">
              {receiveItems.map((r) => (
                <div key={r.label} className="text-center rounded-2xl bg-white/5 border border-white/10 p-6 card-hover">
                  <div className="font-display text-5xl gold-gradient-text">{r.count}</div>
                  <div className="mt-2 text-white font-medium capitalize">{r.label}</div>
                  <div className="mt-1 text-xs text-white/55 leading-relaxed">{r.desc}</div>
                </div>
              ))}
            </div>
            <div className="mt-8 grid md:grid-cols-2 gap-4">
              <div className="flex items-start gap-4 rounded-2xl bg-white/5 border border-white/10 p-5">
                <Radio className="h-6 w-6 text-aqua shrink-0 mt-1" />
                <div>
                  <div className="text-white font-medium">Live mensuel = supervision + calibrage</div>
                  <p className="text-sm text-white/60 mt-1">Approfondissement, réglage de posture, intégration collective, finesse de guidance.</p>
                </div>
              </div>
              <div className="flex items-start gap-4 rounded-2xl bg-white/5 border border-white/10 p-5">
                <Layers className="h-6 w-6 text-aqua shrink-0 mt-1" />
                <div>
                  <div className="text-white font-medium">Communauté de pratique</div>
                  <p className="text-sm text-white/60 mt-1">Ici, tu ne consommes pas. Tu t'affûtes, entouré(e) de praticiens engagés.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
